module.exports = __webpack_public_path__ + "static/media/20240227114050_IMG_5526.5eac20dc.JPG";